"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FormConditionalOperator = void 0;
var FormConditionalOperator;
exports.FormConditionalOperator = FormConditionalOperator;

(function (FormConditionalOperator) {
  FormConditionalOperator["BLANK"] = "blank";
  FormConditionalOperator["CONTAINS"] = "contains";
  FormConditionalOperator["DOES_NOT_CONTAIN"] = "does-not-contain";
  FormConditionalOperator["EQUAL"] = "equal";
  FormConditionalOperator["NOT_EQUAL"] = "not-equal";
  FormConditionalOperator["NOT_BLANK"] = "not-blank";
})(FormConditionalOperator || (exports.FormConditionalOperator = FormConditionalOperator = {}));